import { render } from "./CoursePage.vue?vue&type=template&id=05c8980b&scoped=true"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"

import "./CoursePage.vue?vue&type=style&index=0&id=05c8980b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c8980b"]])

export default __exports__